var map = {
	"./child-power-small.svg": [
		6196,
		6196
	],
	"./childhood-strides-small.svg": [
		4252,
		4252
	],
	"./climate-action-small.svg": [
		2393,
		2393
	],
	"./equality-for-some-small.svg": [
		5624,
		5624
	],
	"./eyes-on-equality-small.svg": [
		9927,
		9927
	],
	"./free-to-be-young-small.svg": [
		8643,
		8643
	],
	"./future-fortunes-small.svg": [
		4292,
		4292
	],
	"./global-citizens-small.svg": [
		2317,
		2317
	],
	"./global-outlook-small.svg": [
		2558,
		2558
	],
	"./go-to-sources-2021-small.svg": [
		7657,
		7657
	],
	"./go-to-sources-small.svg": [
		5105,
		5105
	],
	"./is-scrolling-believing-2021-small.svg": [
		4434,
		4434
	],
	"./is-scrolling-believing-small.svg": [
		8822,
		8822
	],
	"./mental-burdens-small.svg": [
		3160,
		3160
	],
	"./online-opportunities-small.svg": [
		5438,
		5438
	],
	"./online-risks-small.svg": [
		2551,
		2551
	],
	"./the-other-climate-crisis-2021-small.svg": [
		7332,
		7332
	],
	"./the-other-climate-crisis-small.svg": [
		5496,
		5496
	],
	"./under-pressure-small.svg": [
		9313,
		9313
	],
	"./where-you-call-home-2021-small.svg": [
		673,
		673
	],
	"./where-you-call-home-small.svg": [
		6091,
		6091
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 981;
module.exports = webpackAsyncContext;